import { isSameDay, parseISO, set } from "date-fns";
import { useEffect, useState } from 'react';
import { LppItem, StatusFilter } from "../../../../model/Hublang";
import { fetchGetLPPAll, fetchPrintLpp, fetchPetugasAvailable, fetchPatchVerif} from '../../../../controller/dashboard/Loket';
import { fetchLppListBukaDataGet, fetchLppListWPetugas } from "../../../../controller/dashboard/Cekmeter";
import { SquareCheckBig, Printer, Calculator } from "lucide-react";
import { getCache } from "../../../../util/Cache";

interface CustomerRecord {
    periode : string;
    noDRD: string;
    sm: string;
    smLalu: string;
    pakai : string;
    alamat: string;
    msTag: string;
    jumlah: number;
    airPMLimAdm: number;
    nonAir : string;
    materai : string;
    jmlNA: number;
    denda: number;
}

export default function RekAirPelanggan(){
    const [user, setUser] = useState('ALAN ZULFIKAR');
    const [tanggal, setTanggal] = useState('16-01-2026');
    const [loket, setLoket] = useState('');
    const [noLPP, setNoLPP] = useState('');
    const [jmlRek, setJmlRek] = useState(0);
    const [noSamb, setNoSamb] = useState('0500005');
    const [periode, setPeriode] = useState('202601');
    const [bulan, setBulan] = useState('01');
    const [nama, setNama] = useState('');
    const [alamat, setAlamat] = useState('');
    const [status, setStatus] = useState('');
    const [periodeBayar, setPeriodeBayar] = useState('202601');
    const [rekeningDibayar, setRekeningDibayar] = useState('0');
    const [biayaTutup, setBiayaTutup] = useState('0');
    const [totalTagihan, setTotalTagihan] = useState('0');
    const [totalTagihanDibayar, setTotalTagihanDibayar] = useState('0');
    const [modeCetak, setModeCetak] = useState('STANDARD');
    const [cetakUlang, setCetakUlang] = useState('20260105000005');
    const [records, setRecords] = useState<CustomerRecord[]>([]);
    const [page, setPage] = useState('lpp');

    const dateNowDDMMYYYY = (): string => {
        const now = new Date();
        const dd = String(now.getDate()).padStart(2, "0");
        const mm = String(now.getMonth() + 1).padStart(2, "0");
        const yyyy = now.getFullYear();
        return `${dd}-${mm}-${yyyy}`;
    }

    const initDataUser = async () => {
        const dataJson = await getCache('current_user').then((data) => data);
        setUser(dataJson.nama);
        setTanggal(dateNowDDMMYYYY());
        setLoket(dataJson.loket);
        setNoLPP('DPHA' + tanggal.split('-').reverse().join('').slice(2) + '0');
    }

    useEffect(() => {
        initDataUser();
    },[]);

    const PelunasanRekeningAirPelanggan = () => {
        return(
            <>
                {/* Top Section */}
                <div className="grid grid-cols-12 gap-6 mb-6">
                    {/* Left Section */}
                    <div className="col-span-4 space-y-4">
                    <div className="flex items-center gap-3">
                        <label className="w-20 text-sm font-medium text-gray-700">User</label>
                        <input
                        type="text"
                        value={user}
                        readOnly
                        className="flex-1 px-3 py-2 bg-cyan-100 border border-cyan-300 rounded text-sm font-semibold"
                        />
                    </div>
                    <div className="flex items-center gap-3">
                        <label className="w-20 text-sm font-medium text-gray-700">Tanggal</label>
                        <input
                        type="text"
                        value={tanggal}
                        readOnly
                        className="flex-1 px-3 py-2 bg-gray-50 border border-gray-300 rounded text-sm disabled"
                        />
                    </div>
                    <div className="flex items-center gap-3">
                        <label className="w-20 text-sm font-medium text-gray-700">Loket</label>
                        <input
                        type="number"
                        value={loket}
                        readOnly
                        className="w-20 px-3 py-2 bg-cyan-100 border border-cyan-300 rounded text-sm"
                        />
                        <span className="text-gray-500">-</span>
                    </div>

                    <div className="flex gap-2 pt-2">
                        <button onClick={() => { setPage('proses') }} className="flex-1 px-4 py-2 bg-white border-2 border-gray-300 hover:bg-gray-50 rounded text-sm font-medium transition-all">
                        Pelunasan Transfer
                        </button>
                    </div>
                    </div>

                    {/* Center Section */}
                    <div className="col-span-4 space-y-4">
                    <div className="flex items-center gap-3">
                        <label className="w-20 text-sm font-medium text-gray-700">No. LPP</label>
                        <input
                        type="text"
                        value={noLPP}
                        readOnly
                        className="flex-1 px-3 py-2 bg-cyan-100 border border-cyan-300 rounded text-sm font-semibold"
                        />
                    </div>
                    <div className="flex items-center gap-3">
                        <label className="w-20 text-sm font-medium text-gray-700">Jml Rek</label>
                        <input
                        type="number"
                        value={jmlRek}
                        readOnly
                        className="flex-1 px-3 py-2 bg-cyan-100 border border-cyan-300 rounded text-sm"
                        />
                    </div>
                    <button className="w-full px-4 py-2 bg-gradient-to-r from-blue-500 to-cyan-500 hover:from-blue-600 hover:to-cyan-600 text-white rounded font-medium transition-all shadow-md">
                        Cetak LPP
                    </button>
                    <button className="w-full px-4 py-2 bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white rounded font-medium transition-all shadow-md">
                        Cetak Rekap LPP
                    </button>
                    </div>

                    {/* Right Section */}
                    <div className="col-span-4 space-y-3">
                        <div className="flex items-center gap-3">
                            <label className="w-32 text-sm font-medium text-gray-700">Total Kas Air</label>
                            <input
                            type="number"
                            value={0}
                            readOnly
                            className="flex-1 px-3 py-2 bg-cyan-100 border border-cyan-300 rounded text-sm text-right font-semibold"
                            />
                        </div>
                        <div className="flex items-center gap-3">
                            <label className="w-32 text-sm font-medium text-gray-700">Total Kas Non Air</label>
                            <input
                            type="number"
                            value={0}
                            readOnly
                            className="flex-1 px-3 py-2 bg-cyan-100 border border-cyan-300 rounded text-sm text-right font-semibold"
                            />
                        </div>
                        <div className="flex items-center gap-3">
                            <label className="w-32 text-sm font-medium text-gray-700">Total Kas Denda</label>
                            <input
                            type="number"
                            value={0}
                            readOnly
                            className="flex-1 px-3 py-2 bg-cyan-100 border border-cyan-300 rounded text-sm text-right font-semibold"
                            />
                        </div>
                        <div className="flex items-center gap-3">
                            <label className="w-32 text-sm font-medium text-gray-700">Total Nilai LPP</label>
                            <input
                            type="number"
                            value={0}
                            readOnly
                            className="flex-1 px-3 py-2 bg-cyan-100 border border-cyan-300 rounded text-sm text-right font-semibold"
                            />
                        </div>
                    </div>
                </div>

                {/* Middle Section - Rekening Dipilih */}
                <div className="bg-gray-50 p-4 rounded-lg mb-6 border border-gray-200">
                    <h2 className="text-sm font-bold text-gray-700 mb-3">Rekening Dipilih</h2>
                    <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-2 flex items-center gap-2">
                        <label className="text-sm font-medium text-gray-700">No. Smb.</label>
                        <input
                        type="text"
                        value={noSamb}
                        onChange={(e) => setNoSamb(e.target.value)}
                        className="flex-1 px-3 py-2 bg-white border border-gray-300 rounded text-sm"
                        />
                    </div>
                    <div className="col-span-2 flex items-center gap-2">
                        <label className="text-sm font-medium text-gray-700">Periode</label>
                        <input
                        type="text"
                        value={periode}
                        onChange={(e) => setPeriode(e.target.value)}
                        className="flex-1 px-3 py-2 bg-white border border-gray-300 rounded text-sm"
                        />
                    </div>
                    <div className="col-span-3 flex items-center gap-2">
                        <label className="text-sm font-medium text-gray-700">Mode Cetak</label>
                        <select className="w-12 px-2 py-2 bg-white border border-gray-300 rounded text-sm">
                        <option>S</option>
                        </select>
                        <input
                        type="text"
                        value={modeCetak}
                        readOnly
                        className="flex-1 px-3 py-2 bg-cyan-100 border border-cyan-300 rounded text-sm font-medium"
                        />
                    </div>
                    <div className="col-span-5 flex items-center gap-2">
                        <label className="text-sm font-medium text-gray-700">Cetak Ulang</label>
                        <input
                        type="text"
                        value={cetakUlang}
                        readOnly
                        className="flex-1 px-3 py-2 bg-cyan-100 border border-cyan-300 rounded text-sm font-medium"
                        />
                    </div>
                    </div>
                </div>

                {/* Table */}
                <div className="overflow-x-auto border border-gray-300 rounded-lg">
                    <table className="w-full text-sm">
                    <thead className="bg-gradient-to-r from-gray-100 to-gray-200">
                        <tr>
                        <th className="px-3 py-2 text-left font-semibold text-gray-700 border-b border-r border-gray-300">Tanggal</th>
                        <th className="px-3 py-2 text-left font-semibold text-gray-700 border-b border-r border-gray-300">No. Smb.</th>
                        <th className="px-3 py-2 text-left font-semibold text-gray-700 border-b border-r border-gray-300">Nama</th>
                        <th className="px-3 py-2 text-left font-semibold text-gray-700 border-b border-r border-gray-300">Alamat</th>
                        <th className="px-3 py-2 text-left font-semibold text-gray-700 border-b border-r border-gray-300">Ms. Tag</th>
                        <th className="px-3 py-2 text-center font-semibold text-gray-700 border-b border-r border-gray-300 bg-cyan-100">Jumlah</th>
                        <th className="px-3 py-2 text-center font-semibold text-gray-700 border-b border-r border-gray-300">Air.PM.Lim.Adm</th>
                        <th className="px-3 py-2 text-center font-semibold text-gray-700 border-b border-r border-gray-300">Jml. NA</th>
                        <th className="px-3 py-2 text-center font-semibold text-gray-700 border-b border-gray-300">Dnd.Met.BT</th>
                        </tr>
                    </thead>
                    <tbody>
                    {records.length === 0 ? (
                        Array.from({ length: 10 }).map((_, idx) => (
                            <tr key={idx} className="hover:bg-gray-50 transition-colors">
                            <td className="px-2 py-2 border-b border-r border-gray-200">&nbsp;</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200">&nbsp;</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200">&nbsp;</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200">&nbsp;</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200">&nbsp;</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200 bg-cyan-50">&nbsp;</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200">&nbsp;</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200">&nbsp;</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200">&nbsp;</td>
                            <td className="px-2 py-2 border-b border-gray-200">&nbsp;</td>
                            </tr>
                        ))
                        ) : (
                        records.map((record, idx) => (
                            <tr key={idx} className="hover:bg-gray-50 transition-colors">
                            <td className="px-2 py-2 border-b border-r border-gray-200">{record.periode}</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200">{record.noDRD}</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200">{record.sm}</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200">{record.smLalu}</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200">{record.pakai}</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200 bg-cyan-50 text-right">{record.jumlah}</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200 text-right">{record.airPMLimAdm}</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200 text-right">{record.nonAir}</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200 text-right">{record.materai}</td>
                            <td className="px-2 py-2 border-b border-gray-200 text-right">{record.denda}</td>
                            </tr>
                        ))
                        )}
                    </tbody>
                    </table>
                </div>
            </>
        );
    }

    const PelunasanRekeningAir = () => {
        return(
            <>
                {/* Top Section */}
                <div className="grid grid-cols-2 gap-6 mb-4">
                    {/* Left Panel */}
                    <div className="space-y-3">
                    {/* Mode Cetak & Standard */}
                    <div className="flex items-center gap-2">
                        <label className="w-24 text-sm font-medium text-gray-700">Mode Cetak</label>
                        <select 
                            value={modeCetak}
                            onChange={(e) => setModeCetak(e.target.value)}
                            className="w-16 px-2 py-1.5 bg-white border border-gray-300 rounded text-sm"
                        >
                            <option>S</option>
                            <option>A</option>
                        </select>
                        <input
                            type="text"
                            value="STANDARD"
                            readOnly
                            className="flex-1 px-3 py-1.5 bg-cyan-100 border border-cyan-300 rounded text-sm font-semibold"
                        />
                    </div>

                    {/* No. Samb */}
                    <div className="flex items-center gap-2">
                        <label className="w-24 text-sm font-medium text-gray-700">No. Samb.</label>
                        <input
                        type="text"
                        value={noSamb}
                        onChange={(e) => setNoSamb(e.target.value)}
                        className="flex-1 px-3 py-1.5 bg-cyan-100 border border-cyan-300 rounded text-sm font-semibold"
                        />
                    </div>

                    {/* Tahun & Bulan */}
                    <div className="flex items-center gap-2">
                        <label className="w-24 text-sm font-medium text-gray-700">Tahun</label>
                        <input
                        type="text"
                        value={periode}
                        onChange={(e) => setPeriode(e.target.value)}
                        className="w-24 px-3 py-1.5 bg-cyan-100 border border-cyan-300 rounded text-sm font-semibold"
                        />
                        <label className="text-sm font-medium text-gray-700">Bulan</label>
                        <input
                        type="text"
                        value={bulan}
                        onChange={(e) => setBulan(e.target.value)}
                        className="w-16 px-3 py-1.5 bg-cyan-100 border border-cyan-300 rounded text-sm font-semibold"
                        />
                        <button className="px-4 py-1.5 bg-gradient-to-r from-blue-500 to-cyan-500 hover:from-blue-600 hover:to-cyan-600 text-white rounded text-sm font-medium transition-all shadow">
                        Proses
                        </button>
                    </div>

                    {/* Nama */}
                    <div className="flex items-center gap-2">
                        <label className="w-24 text-sm font-medium text-gray-700">Nama</label>
                        <input
                        type="text"
                        value={nama}
                        onChange={(e) => setNama(e.target.value)}
                        className="flex-1 px-3 py-1.5 bg-cyan-100 border border-cyan-300 rounded text-sm"
                        />
                    </div>

                    {/* Alamat */}
                    <div className="flex items-center gap-2">
                        <label className="w-24 text-sm font-medium text-gray-700">Alamat</label>
                        <input
                        type="text"
                        value={alamat}
                        onChange={(e) => setAlamat(e.target.value)}
                        className="flex-1 px-3 py-1.5 bg-cyan-100 border border-cyan-300 rounded text-sm"
                        />
                    </div>

                    {/* Status & Go */}
                    <div className="flex items-center gap-2">
                        <label className="w-24 text-sm font-medium text-gray-700">Status</label>
                        <input
                            type="text"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                            className="flex-1 px-3 py-1.5 bg-cyan-100 border border-cyan-300 rounded text-sm"
                        />
                    </div>
                    <div className="flex items-center gap-2">
                        <button onClick={() => { setPage('lpp') }} className="flex-1 px-4 py-1.5 bg-white border-2 border-gray-400 hover:bg-gray-50 rounded text-sm font-medium transition-all">
                            Kembali
                        </button>
                        <button className="px-6 py-1.5 bg-gradient-to-r from-gray-400 to-gray-500 hover:from-gray-500 hover:to-gray-600 text-white rounded text-sm font-medium transition-all shadow">
                        Go!
                        </button>
                    </div>
                    </div>

                    {/* Right Panel */}
                    <div className="space-y-3">
                    {/* Loket */}
                    <div className="flex items-center gap-2">
                        <label className="w-32 text-sm font-medium text-gray-700">Loket</label>
                        <input
                        type="text"
                        value={loket}
                        onChange={(e) => setLoket(e.target.value)}
                        className="w-20 px-3 py-1.5 bg-cyan-100 border border-cyan-300 rounded text-sm"
                        />
                        <span className="text-gray-400">-</span>
                    </div>

                    {/* No. LPP */}
                    <div className="flex items-center gap-2">
                        <label className="w-32 text-sm font-medium text-gray-700">No. LPP</label>
                        <input
                        type="text"
                        value={noLPP}
                        onChange={(e) => setNoLPP(e.target.value)}
                        className="flex-1 px-3 py-1.5 bg-cyan-100 border border-cyan-300 rounded text-sm font-semibold"
                        />
                    </div>

                    {/* Tanggal */}
                    <div className="flex items-center gap-2">
                        <label className="w-32 text-sm font-medium text-gray-700">Tanggal</label>
                        <input
                        type="text"
                        value={tanggal}
                        onChange={(e) => setTanggal(e.target.value)}
                        className="flex-1 px-3 py-1.5 bg-cyan-100 border border-cyan-300 rounded text-sm"
                        />
                        <label className="text-sm font-medium text-gray-700">Periode Bayar</label>
                        <input
                        type="text"
                        value={periodeBayar}
                        onChange={(e) => setPeriodeBayar(e.target.value)}
                        className="w-24 px-3 py-1.5 bg-cyan-100 border border-cyan-300 rounded text-sm"
                        />
                    </div>

                    {/* Buttons Row */}
                    <div className="flex gap-2">
                        <button className="flex-1 px-4 py-1.5 bg-white border-2 border-gray-400 hover:bg-gray-50 rounded text-sm font-medium transition-all">
                        Keluar
                        </button>
                        <button className="flex-1 px-4 py-1.5 bg-white border-2 border-gray-400 hover:bg-gray-50 rounded text-sm font-medium transition-all">
                        Cari Pelanggan
                        </button>
                    </div>

                    {/* Rekening Dibayar */}
                    <div className="flex items-center gap-2">
                        <label className="w-32 text-sm font-medium text-gray-700">Rekening Dibayar</label>
                        <input
                        type="text"
                        value={rekeningDibayar}
                        readOnly
                        className="flex-1 px-3 py-1.5 bg-cyan-100 border border-cyan-300 rounded text-sm text-right font-semibold"
                        />
                    </div>

                    {/* Biaya Tutup */}
                    <div className="flex items-center gap-2">
                        <label className="w-32 text-sm font-medium text-gray-700">Biaya Tutup</label>
                        <input
                        type="text"
                        value={biayaTutup}
                        readOnly
                        className="flex-1 px-3 py-1.5 bg-cyan-100 border border-cyan-300 rounded text-sm text-right font-semibold"
                        />
                    </div>

                    {/* Total tagihan */}
                    <div className="flex items-center gap-2">
                        <label className="w-32 text-sm font-medium text-gray-700">Total tagihan</label>
                        <div className="flex-1 px-3 py-1.5 bg-black text-green-400 rounded text-sm text-right font-bold text-xl">
                        {totalTagihan}
                        </div>
                    </div>
                    </div>
                </div>

                {/* Table */}
                <div className="overflow-x-auto border border-gray-300 rounded-lg mb-4">
                    <table className="w-full text-sm">
                    <thead className="bg-gradient-to-r from-gray-100 to-gray-200">
                        <tr>
                        <th className="px-2 py-2 text-left font-semibold text-gray-700 border-b border-r border-gray-300 w-20">Periode</th>
                        <th className="px-2 py-2 text-left font-semibold text-gray-700 border-b border-r border-gray-300 w-24">No. DRD</th>
                        <th className="px-2 py-2 text-left font-semibold text-gray-700 border-b border-r border-gray-300 w-20">SM</th>
                        <th className="px-2 py-2 text-left font-semibold text-gray-700 border-b border-r border-gray-300 w-20">SM Lalu</th>
                        <th className="px-2 py-2 text-left font-semibold text-gray-700 border-b border-r border-gray-300 w-20">Pakai</th>
                        <th className="px-2 py-2 text-center font-semibold text-gray-700 border-b border-r border-gray-300 bg-cyan-100">Jumlah</th>
                        <th className="px-2 py-2 text-center font-semibold text-gray-700 border-b border-r border-gray-300">Air.PM.Lim.Adm</th>
                        <th className="px-2 py-2 text-center font-semibold text-gray-700 border-b border-r border-gray-300">Non Air</th>
                        <th className="px-2 py-2 text-center font-semibold text-gray-700 border-b border-r border-gray-300">Materai</th>
                        <th className="px-2 py-2 text-center font-semibold text-gray-700 border-b border-gray-300">Denda</th>
                        </tr>
                    </thead>
                    <tbody>
                        {records.length === 0 ? (
                        Array.from({ length: 10 }).map((_, idx) => (
                            <tr key={idx} className="hover:bg-gray-50 transition-colors">
                            <td className="px-2 py-2 border-b border-r border-gray-200">&nbsp;</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200">&nbsp;</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200">&nbsp;</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200">&nbsp;</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200">&nbsp;</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200 bg-cyan-50">&nbsp;</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200">&nbsp;</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200">&nbsp;</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200">&nbsp;</td>
                            <td className="px-2 py-2 border-b border-gray-200">&nbsp;</td>
                            </tr>
                        ))
                        ) : (
                        records.map((record, idx) => (
                            <tr key={idx} className="hover:bg-gray-50 transition-colors">
                            <td className="px-2 py-2 border-b border-r border-gray-200">{record.periode}</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200">{record.noDRD}</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200">{record.sm}</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200">{record.smLalu}</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200">{record.pakai}</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200 bg-cyan-50 text-right">{record.jumlah}</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200 text-right">{record.airPMLimAdm}</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200 text-right">{record.nonAir}</td>
                            <td className="px-2 py-2 border-b border-r border-gray-200 text-right">{record.materai}</td>
                            <td className="px-2 py-2 border-b border-gray-200 text-right">{record.denda}</td>
                            </tr>
                        ))
                        )}
                    </tbody>
                    </table>
                </div>

                {/* Bottom Section */}
                <div className="flex items-center gap-4">
                    <label className="text-sm font-medium text-gray-700">Total Tagihan Dibayar :</label>
                    <div className="px-6 py-2 bg-black text-green-400 rounded text-lg font-bold min-w-[120px] text-center">
                    {totalTagihanDibayar}
                    </div>
                    <button className="px-6 py-2 bg-gradient-to-r from-red-500 to-orange-500 hover:from-red-600 hover:to-orange-600 text-white rounded font-medium transition-all shadow-md flex items-center gap-2">
                    <span className="text-lg">⚠️</span>
                    Reset
                    </button>
                </div>
            </>
        );
    }

    return (
        <div className="min-h-screen p-4">
                <div className="bg-white rounded-lg shadow-2xl overflow-hidden">
                    {/* Header */}
                    <div className="bg-gradient-to-r from-cyan-500 to-blue-600 text-white px-6 py-4 flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <Printer className="w-6 h-6" />
                            <h1 className="text-xl font-bold">Pelunasan Rekening Air Pelanggan</h1>
                        </div>
                    </div>

                    {/* Main Content */}
                    <div className="p-6">
                        {
                            page === 'lpp' ? 
                            <PelunasanRekeningAirPelanggan />
                            :
                            <PelunasanRekeningAir />
                        }
                    </div>
                </div>
        </div>
    );
};